import { createRouter, createWebHistory } from 'vue-router';
import { useUsers } from '@/features/users/controller';

const routes = [
  {
    path: '/',
    name: 'welcome',
    component: () => import('@/views/WelcomeView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/catalogue',
    name: 'home',
    component: () => import('@/views/HomeView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/choix-connexion',
    name: 'login-choice',
    component: () => import('@/views/LoginChoiceView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/connexion',
    name: 'login',
    component: () => import('@/views/LoginView.vue'),
    meta: { requiresAuth: false }
  },
  // Route d'inscription conservée pour compatibilité (redirige vers login)
  {
    path: '/inscription',
    name: 'register',
    redirect: { name: 'login', query: { type: 'particulier' } }
  },
  {
    path: '/mot-de-passe-oublie',
    name: 'forgot-password',
    component: () => import('@/views/ForgotPasswordView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/reinitialiser-mot-de-passe',
    name: 'reset-password',
    component: () => import('@/views/ResetPasswordView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/activate-account',
    name: 'activate-account',
    component: () => import('@/views/ActivateAccountView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/categorie/:id',
    name: 'category',
    component: () => import('@/views/CategoryView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/produit/:id',
    name: 'product',
    component: () => import('@/views/ProductView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/panier',
    name: 'cart',
    component: () => import('@/views/CartView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/commande-confirmee',
    name: 'order-confirmation',
    component: () => import('@/views/OrderConfirmationView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/mandat-succes',
    name: 'mandate-success',
    component: () => import('@/views/MandateSuccessView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/mandat-erreur',
    name: 'mandate-error',
    component: () => import('@/views/MandateErrorView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: "/",
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const $userStore = useUsers();

  if (to.meta.requiresAuth && !$userStore.loggedUser) {
    await $userStore.getUser();
    if (!$userStore.loggedUser) return next('/');
  }

  next();
});

export default router;
